import BaseMiniPrinterDriver from './base-miniprinter-driver'
import miniprinterXL from '../../assets/models/miniprinter-xl.stl'
import { MiniPrinterIcon, AddMiniPrinterIcon } from '../../components/icons'

class MiniPrinterXLDriver extends BaseMiniPrinterDriver {
  static readonly name = 'MiniPrinter XL'
  static readonly model = 'miniprinter-xl'
  static readonly icon = MiniPrinterIcon
  static readonly addIcon = AddMiniPrinterIcon
  static readonly stlModel = miniprinterXL
  protected static readonly stlModelXOffset: number = -0.46
  protected static readonly stlModelYOffset: number = -0.23
  protected static readonly stlModelZOffset: number = -0.175

  protected static readonly HEIGHT_MM: number = 1200
  protected static readonly WIDTH_MM: number = 2500
  protected static readonly DEPTH_MM: number = 1200
}

export default MiniPrinterXLDriver
